<ion-col
  [attr.data-cy]="
    'sortable-section-header-' + headerName?.toLowerCase() + '-column'
  "
>
  <div
    [attr.data-cy]="
      'sortable-section-header-' + headerName?.toLowerCase() + '-section'
    "
    class="sortable-section-header-option"
    [class.sort-active]="selectedHeader === headerName"
    (click)="handleUpdateSortEvent()"
  >
    <p
      [attr.data-cy]="
        'sortable-section-header-' + headerName?.toLowerCase() + '-label'
      "
    >
      {{ displayText | translate }}
    </p>
    <div
      [attr.data-cy]="
        'sortable-section-header-' +
        headerName?.toLowerCase() +
        '-caret-section'
      "
      class="caret-icon"
    >
      <ion-icon
        *ngIf="
          (selectedHeader !== headerName && sortDirection) ||
          (selectedHeader === headerName &&
            sortDirection === SortDirections.asc)
        "
        [attr.data-cy]="
          'sortable-section-header-' +
          headerName?.toLowerCase() +
          '-caret-up-icon'
        "
        name="caret-up-outline"
      ></ion-icon>
      <ion-icon
        *ngIf="
          (selectedHeader !== headerName && sortDirection) ||
          (selectedHeader === headerName &&
            sortDirection === SortDirections.desc)
        "
        [attr.data-cy]="
          'sortable-section-header-' + headerName?.toLowerCase() + '-down-icon'
        "
        name="caret-down-outline"
      ></ion-icon>
    </div>
  </div>
</ion-col>
